/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/mrz/MRZScannerIntroScreenConfiguration.yaml
import { BackgroundStyle, ButtonConfiguration, ForegroundStyle, StyledText } from '../common/Common';
/** @internal */
export var MrzScannerIntroImage;
(function (MrzScannerIntroImage) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'MrzIntroDefaultImage':
                return new MrzIntroDefaultImage(source);
            case 'MrzIntroNoImage':
                return new MrzIntroNoImage(source);
            case 'MrzIntroCustomImage':
                return new MrzIntroCustomImage(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    MrzScannerIntroImage.from = from;
})(MrzScannerIntroImage || (MrzScannerIntroImage = {}));
/**
No image for the introduction screen.
*/
export class MrzIntroDefaultImage {
    /** @param source {@displayType `DeepPartial<MrzIntroDefaultImage>`} */
    constructor(source = {}) {
        this._type = 'MrzIntroDefaultImage';
    }
}
/**
No image for the introduction screen.
*/
export class MrzIntroNoImage {
    /** @param source {@displayType `DeepPartial<MrzIntroNoImage>`} */
    constructor(source = {}) {
        this._type = 'MrzIntroNoImage';
    }
}
/**
A custom image for the introduction screen.
*/
export class MrzIntroCustomImage {
    /** @param source {@displayType `DeepPartial<MrzIntroCustomImage>`} */
    constructor(source = {}) {
        this._type = 'MrzIntroCustomImage';
        if (source.uri !== undefined) {
            this.uri = source.uri;
        }
        else {
            throw new Error('uri must be present in constructor argument');
        }
    }
}
/**
Configuration of the introduction screen for the MRZ scanner.
*/
export class MrzScannerIntroScreenConfiguration {
    /** @param source {@displayType `DeepPartial<MrzScannerIntroScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          The image for the introduction screen.
          */
        this.image = new MrzIntroDefaultImage({});
        /**
          The background color of the introduction screen.
          
          Default is "?sbColorSurface"
          */
        this.backgroundColor = '?sbColorSurface';
        /**
          The divider color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.dividerColor = '?sbColorOutline';
        /**
          The handle color of the introduction screen.
          
          Default is "?sbColorOutline"
          */
        this.handlerColor = '?sbColorOutline';
        /**
          Determines whether the introduction screen should automatically be shown or not when the scanning session starts.
          
          Default is false
          */
        this.showAutomatically = false;
        /**
          The title of the introduction screen, located in the top bar.
          */
        this.title = new StyledText({ text: '?introScreenTitle', color: '?sbColorOnSurface' });
        /**
          The text explanation of the introduction screen.
          */
        this.explanation = new StyledText({ text: '?introScreenText', color: '?sbColorOnSurface' });
        /**
          Configuration of the 'Done' / 'Start scanning' button.
          */
        this.doneButton = new ButtonConfiguration({
            text: '?introScreenDoneButton',
            accessibilityDescription: '?accessibilityDescriptionIntroScreenDoneButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '?sbColorPrimary', strokeWidth: 0.0 }),
            foreground: new ForegroundStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.image !== undefined) {
            this.image = MrzScannerIntroImage.from(source.image);
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.dividerColor !== undefined) {
            this.dividerColor = source.dividerColor;
        }
        if (source.handlerColor !== undefined) {
            this.handlerColor = source.handlerColor;
        }
        if (source.showAutomatically !== undefined) {
            this.showAutomatically = source.showAutomatically;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.explanation !== undefined) {
            this.explanation = new StyledText(source.explanation);
        }
        if (source.doneButton !== undefined) {
            this.doneButton = new ButtonConfiguration(source.doneButton);
        }
    }
}
//# sourceMappingURL=MrzScannerIntroScreenConfiguration.js.map